import React from 'react';
import ImageViewer from 'react-simple-image-viewer';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import { Loader } from '../../components';

const useStyles = makeStyles(() => ({
  paperView: {
    backgroundColor: 'transparent',
  },
}));

export const FileViewer = ({ images = [], onClose, open, loading }: any) => {
  const classes = useStyles();
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      PaperProps={{ elevation: 0, className: classes.paperView }}
    >
      <Loader loading={loading}>
        <ImageViewer
          src={images}
          currentIndex={0}
          onClose={onClose}
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0)',
          }}
        />
      </Loader>
    </Dialog>
  );
};
